import { createContext, useState } from 'react'

import { api } from 'utils/api'
import { getError } from 'utils/helpers/getError'
import { useCustomContext } from 'utils/helpers/useCustomContext'
import { GenericResponse, GenericStateType } from 'utils/types'

import { OwnerSubmitType, OwnerValidationContextType, OwnerValidationStateType } from './ownerValidationTypes'

const INITIAL_OWNER_VALIDATION_STEP_CONTEXT: OwnerValidationContextType = {
  setLoading: () => null,
  setError: () => null,
  clearError: () => null,
  clearContent: () => null,
  sendOwnerDocuments: () => new Promise(() => null),
  ownerValidationState: {
    error: '',
    loading: false,
    state: {
      isResult: false
    },
  },
}

const OwnerValidationStepContext = createContext<OwnerValidationContextType>(
  INITIAL_OWNER_VALIDATION_STEP_CONTEXT,
)

const OwnerValidationProvider: React.FC = ({ children }) => {
  const [ownerValidationStepState, setOwnerValidationStepState] = useState<
    GenericStateType<OwnerValidationStateType>
  >(INITIAL_OWNER_VALIDATION_STEP_CONTEXT.ownerValidationState)

  const setLoading = (value = true) =>
    setOwnerValidationStepState(prevState => ({ ...prevState, loading: value }))

  const setError = (msg: string) =>
    setOwnerValidationStepState(prevState => ({ ...prevState, loading: false, error: msg }))

  const clearError = () =>
    setOwnerValidationStepState(prevState => ({ ...prevState, error: '' }))


  const clearContent = () =>
    setOwnerValidationStepState(prevState => ({
      ...prevState,
      error: '',
      loading: false,
      state: {
        ...prevState.state,
        isResult: false
      },
    }))

  const sendOwnerDocuments = async (data: OwnerSubmitType, vin: string) => {
    try {
      setLoading()

      const { fileOne, fileTwo, fileThree } = data

      const bodyFormData = new FormData()

      bodyFormData.append('front', fileOne || '')
      bodyFormData.append('back', fileTwo || '')
      bodyFormData.append('document', fileThree || '')

      await api.post<GenericResponse<boolean>>(`Vehicles/${vin}/SendOwnerDocuments`, bodyFormData)

      setOwnerValidationStepState(prevState => ({
        ...prevState,
        loading: false,
        state: {
          ...prevState.state,
          isResult: true,
        },
      }))

      setLoading(false)
    } catch (err) {
      const msg = getError(err)

      setError(msg)
    }

  }


  return (
    <OwnerValidationStepContext.Provider
      value={{
        ownerValidationState: ownerValidationStepState,
        setLoading,
        setError,
        clearError,
        clearContent,
        sendOwnerDocuments,
      }}>
      {children}
    </OwnerValidationStepContext.Provider>
  )
}

const useOwnerValidationStep = () => useCustomContext(OwnerValidationStepContext)

export { OwnerValidationProvider, useOwnerValidationStep }
